import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dubbing_track",
  "use": "icon-dubbing_track-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-dubbing_track\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M21,3V9H19V5H15V3ZM9,3V5H5V9H3V3Zm8,6v6H15V9ZM9,9v6H7V9Zm4-3V18H11V6Zm8,9v6H15V19h4V15ZM5,15v4H9v2H3V15Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol